import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone, AlertCircle, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { siteConfig } from "../config/siteConfig";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/sobre", label: "Sobre" },
  { to: "/servicos", label: "Serviços" },
  { to: "/contato", label: "Contato" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const waUrl = `https://wa.me/${siteConfig.contact.whatsappRaw}?text=${encodeURIComponent(
    siteConfig.contact.whatsappMessage,
  )}`;

  return (
    <>

      {/* Main header */}
      <header
        className="sticky top-0 z-50 backdrop-blur-xl bg-white/95 border-b border-slate-200"
        data-testid="site-header"
      >
        <div className="container-site flex items-center justify-between py-4">
          <Link to="/" data-testid="header-home-link">
            <Logo />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `text-sm font-semibold tracking-wide transition-colors ${
                    isActive
                      ? "text-green-700"
                      : "text-slate-700 hover:text-[#0f2a4a]"
                  }`
                }
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={`tel:${siteConfig.contact.phoneRaw}`}
              className="flex items-center gap-2 text-sm font-bold text-[#0f2a4a] hover:text-[#008000] transition"
              data-testid="header-phone"
            >
              <Phone className="w-4 h-4" />
              {siteConfig.contact.phone}
            </a>
            <a
              href={waUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-green-600 hover:bg-green-700 text-white text-sm font-bold rounded-sm transition shadow-sm hover:shadow-md"
              data-testid="header-whatsapp-btn"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden p-2 text-[#0f2a4a]"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile nav */}
        {open && (
          <div
            className="md:hidden border-t border-slate-200 bg-white"
            data-testid="mobile-menu"
          >
            <nav className="container-site py-4 flex flex-col gap-3">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `py-2 text-base font-semibold ${
                      isActive ? "text-blue-700" : "text-slate-700"
                    }`
                  }
                  data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                >
                  {item.label}
                </NavLink>
              ))}
              <div className="flex gap-3 pt-3 border-t border-slate-100">
                <a
                  href={`tel:${siteConfig.contact.phoneRaw}`}
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 border border-[#0f2a4a] text-[#0f2a4a] text-sm font-bold rounded-sm"
                  data-testid="mobile-phone-btn"
                >
                  <Phone className="w-4 h-4" />
                  Ligar
                </a>
                <a
                  href={waUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-green-600 hover:bg-green-700 text-white text-sm font-bold rounded-sm"
                  data-testid="mobile-whatsapp-btn"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp
                </a>
              </div>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
